const slug = (name = "") =>
  String(name)
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "");

const FILE = {
  "155": "155.svg",
  "1spin4win": "1spin4wins.svg",
  "1spin4wins": "1spin4wins.svg",
  spin4win: "1spin4wins.svg",
  "7rings": "7rings.svg",
  aceroll: "aceroll.webp",
  alohagaming: "alohagaming.webp",
  avatarux: "avatarux.svg",
  bgaming: "b-gaming.svg",
  backseat: "backseat.svg",
  backseatgaming: "backseat.svg",
  betsoft: "betsoft.svg",
  bigtimegaming: "bigtimegaming.svg",
  btg: "bigtimegaming.svg",
  bullshark: "bullshark.svg",
  bullsharkgames: "bullshark.svg",
  delulu: "delulu.webp",
  elk: "elk-studios.svg",
  elkstudios: "elk-studios.svg",
  endorphina: "endorphina.webp",
  egtdigital: "egtdigital.png",
  evolution: "evolution.svg",
  evolutiongaming: "evolution.svg",
  ezugi: "ezugi.png",
  ezugiz: "ezugi.png",
  ezugix: "ezugi.png",
  exco: "exco.svg",
  fantasma: "fantasma.svg",
  fantasmagames: "fantasma.svg",
  fourleaf: "fourleaf.svg",
  fourleafgaming: "fourleaf.svg",
  gamingcorps: "gamingcorps.svg",
  goodtimes: "goodtimes.svg",
  goodtimesstudios: "goodtimes.svg",
  hacksaw: "hacksaw.svg",
  hacksawgaming: "hacksaw.svg",
  justslots: "justslots.svg",
  kitsune: "kitsune.svg",
  kitsunestudios: "kitsune.svg",
  maxxi: "maxxilabs.svg",
  maxxilabs: "maxxilabs.svg",
  netent: "netent.svg",
  nolimit: "nolimit.svg",
  nolimitcity: "nolimit.svg",
  novomatic: "novomatic.webp",
  nownow: "nownow.svg",
  nownowgaming: "nownow.svg",
  onetouch: "onetouch.svg",
  penguin: "penguin-king.svg",
  penguinking: "penguin-king.svg",
  peterandsons: "peter-sons.svg",
  peterssons: "peter-sons.svg",
  petersons: "peter-sons.svg",
  pineapple: "pineappleplay.svg",
  pineappleplay: "pineappleplay.svg",
  playnetic: "playnetic.svg",
  pg: "pocketgamessoft.svg",
  pgsoft: "pocketgamessoft.svg",
  pocketgamesoft: "pocketgamessoft.svg",
  pocketgamessoft: "pocketgamessoft.svg",
  pragmatic: "pragmatic.svg",
  pragmaticplay: "pragmatic.svg",
  pragmaticlive: "pragmatic-live.svg",
  pragmaticblackjack: "pragmatic-live.svg",
  printstudio: "printstudios.svg",
  printstudios: "printstudios.svg",
  push: "pushgaming.svg",
  pushgaming: "pushgaming.svg",
  redtiger: "redtiger.svg",
  relax: "relax-gaming.svg",
  relaxgaming: "relax-gaming.svg",
  shadylady: "shady-lady.svg",
  thunderkick: "thunderkick.svg",
  truelab: "truelabs.svg",
  truelabs: "truelabs.svg",
  trusty: "trustygaming.svg",
  trustygaming: "trustygaming.svg",
  voltent: "voltent.svg",
  wicked: "wickedgames.svg",
  wickedgames: "wickedgames.svg",
  winfast: "winfast.svg",
};

const tones = ["#1d4ed8", "#be123c", "#047857", "#b45309", "#6d28d9", "#0f766e", "#9f1239", "#1e3a8a"];

export const providerInitials = (name = "") => {
  const parts = String(name).trim().split(/[\s'/+-]+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const providerTone = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return tones[Math.abs(hash) % tones.length];
};

export const getProviderLogo = (name, remote) => {
  const src = String(remote || "").trim();
  if (src.startsWith("/providers/")) return src;
  const file = FILE[slug(name)];
  if (file) return `/providers/${file}?v=${file === "egtdigital.png" ? 2 : 1}`;
  if (src.startsWith("/") && !src.startsWith("//") && !/drakon|gator\./i.test(src)) return src;
  return "";
};
